import { ref, computed } from 'vue';
import type { FileUpload, UploadState } from '../components/types';

export function useFileUpload() {
    const state = ref<UploadState>({
        uploads: [],
        isUploading: false,
        dragActive: false
    });

    const addFiles = (files: FileList) => {
        const newUploads: FileUpload[] = Array.from(files).map(file => ({
            id: crypto.randomUUID(),
            file,
            progress: 0,
            status: 'pending'
        }));

        state.value.uploads = [...state.value.uploads, ...newUploads];

    };

    const removeFile = (id: string) => {
        state.value.uploads = state.value.uploads.filter(upload => upload.id !== id);
    };

    const updateProgress = (id: string, progress: number) => {
        const upload = state.value.uploads.find(u => u.id === id);
        if (upload) {
            upload.progress = progress;
            upload.status = progress === 100 ? 'complete' : 'uploading';
        }
    };

    const setDragActive = (active: boolean) => {
        state.value.dragActive = active;
    };

    const totalProgress = computed(() => {
        if (!state.value.uploads.length) return 0;
        const total = state.value.uploads.reduce((sum, upload) => sum + upload.progress, 0);
        return Math.round(total / state.value.uploads.length);
    });

    return {
        state,
        addFiles,
        removeFile,
        updateProgress,
        setDragActive,
        totalProgress
    };
}